import { Component, Inject, Input } from '@angular/core';
import { GRAY_UI_CONFIG, IGrayUiConfig } from "../../ui.config";

@Component({
  selector: 'app-user-profile-img',
  templateUrl: './user-profile-img.component.html',
  styleUrl: './user-profile-img.component.scss'
})
export class UserProfileImgComponent {
  @Input() image?: string;
  @Input() width = '55px';
  @Input() height = '55px';
  @Input() hasLevel = false;
  defaultImg: string;

  constructor(
    @Inject(GRAY_UI_CONFIG) uiConfig: IGrayUiConfig,
  ) {
    this.defaultImg = uiConfig.defaultProfilePhoto;
  }
}
